export default {"src":"/_next/static/media/mind_blown.42769752.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};